export enum TextLineHeightValue {
  ONE = 1,
  ONE_POINT_FIFTEEN = 1.15,
  ONE_POINT_TWO = 1.2,
  ONE_POINT_FIVE = 1.5,
  TWO = 2,
}

// TODO: [#defaultStyles] we need to move all default styles to 1 place
export const DefaultLineHeight = TextLineHeightValue.ONE_POINT_FIVE;
